module.exports = __webpack_public_path__ + "static/media/scan.214dafe2.svg";